// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2KFoo","content":"Consent_content__3QVlX","footer":"Consent_footer__2vDQq"};